<template>
  <div v-if="isMobile">
    <div
      v-if="state.user"
      class="w-full relative"
      :class="{ 'profile-default-cover': userCoverId === 0 }"
      :style="{
        height: '132px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        ...(userCoverId !== 0 && { backgroundImage: `url(${userCoverUrl})` }),
      }"
    >
      <OAvatar
        class="w-24 h-24 rounded-full border-4 border-white absolute left-5 -bottom-12"
        style="width: 96px"
        fallback-class="text-32"
        :src="userAvatarUrl"
        :alt="state.user.name"
        :srcset="userAvatarSrcset"
        :sizes="userAvatarSizes"
      ></OAvatar>
      <UserLeaderboard v-if="IS_ONEDIO" />
    </div>
  </div>
  <div v-else class="">
    <div id="cover" class="relative w-full h-48 object-cover" :class="{ 'profile-default-cover': userCoverId === 0 }" alt="Default Cover">
      <OAvatar
        v-if="state.user"
        class="w-32 h-32 flex-shrink-0 -mt-12 border-4 border-white rounded-full absolute left-5 -bottom-24"
        bg="bg-[#c5c5c5]"
        fallback-class="text-64"
        :src="userAvatarUrl"
        :alt="state.user.name"
        :srcset="userAvatarSrcset"
        :sizes="userAvatarSizes"
      ></OAvatar>
      <UserLeaderboard v-if="IS_ONEDIO" />
    </div>
  </div>
</template>

<script>
import { defineComponent, watch, computed, ref } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import { useProfile } from '@/modules/profile/state/useProfile';
import { OAvatar } from '@/modules/common/components/ui';
import UserLeaderboard from '@/modules/oyun/components/leaderboard/UserLeaderboard';
import { getImageResponsiveAttributes, getImageUrl } from '~/modules/common/utils/imageUtils';
import { IS_ONEDIO } from '~/constants/config';
export default defineComponent({
  components: {
    OAvatar,
    UserLeaderboard,
  },
  setup() {
    const { isMobile } = useDevice();
    const { state } = useProfile();

    const {
      src: userAvatarUrl,
      srcset: userAvatarSrcset,
      sizes: userAvatarSizes,
    } = getImageResponsiveAttributes(state.value.user?.avatar, {
      screens: {
        desktop: '240px',
        mobile: '120px',
      },
      customSizes: [
        { width: 120, height: 120 },
        { width: 240, height: 240 },
      ],
    });

    const userCoverId = computed(() => state.value.user?.cover?.id);
    const userCoverUrl = getImageUrl(state.value.user?.cover, { width: 1100 });
    const setCoverImageStyle = () => {
      const coverImage = document.getElementById('cover');
      if (!coverImage) return;
      if (userCoverId.value !== 0) {
        coverImage.style.background = `url(${userCoverUrl}) no-repeat`;
        coverImage.style.backgroundSize = '1100px';
        coverImage.style.backgroundPosition = `0px -${coverOffset.value}px`;
      }
    };
    const coverOffset = ref(state.value.user?.coverOffset || 0);
    if (process.client && !isMobile.value) {
      setCoverImageStyle();
    }
    watch(isMobile, () => {
      setTimeout(() => {
        setCoverImageStyle();
      }, 10);
    });

    return { isMobile, state, userCoverId, userCoverUrl, userAvatarUrl, userAvatarSrcset, userAvatarSizes, IS_ONEDIO };
  },
});
</script>

<style lang="scss" scoped>
.profile-default-cover {
  background: rgb(44, 123, 161);
  background: linear-gradient(
    91.89deg,
    rgb(44, 123, 161) 0%,
    rgb(111, 190, 222) 17.92%,
    rgb(143, 214, 235) 36.39%,
    rgb(146, 214, 232) 54.95%,
    rgb(84, 165, 196) 81.98%,
    rgb(25, 91, 131) 99.89%
  );
}
</style>
